export const ADMIN = 'bmwfadmin'
export const BACKEND = 'backend'
export const STANDARD = 'bmwfstand'
export const BMWSTANDARD = 'bmwfstand'
export const HOTKEY = 'bmwfhotkey'
export const USER = 'user'

export const ROLE_OPTIONS = []